import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import './style.scss';

const CompactCard = ({
  variant,
  onClick,
  label,
  subtitle,
  title,
  active,
  paddingTitle,
  paddingContent,
  customSize,
  titleClass = '',
  subtitleClass = ''
}) => (
  <Card className={`compact-card bl-0 ${active ? 'active-card' : ''} card-${variant}`} onClick={onClick}>
    <div className="d-flex flex-row">
      {active && <span className="active-border" />}
      <Card.Body className="compact-card-body">
        <div className={`flex-col my-auto ${paddingContent || active ? '' : 'inactive-margin'}`}>
          <Card.Subtitle className="mb-2" style={{ fontSize: '12px' }}>
            {label}
          </Card.Subtitle>
          <div className="d-flex flex-row">
            <Card.Title className={` ${customSize} ${titleClass}`}>{title}</Card.Title>
            {subtitle && (
              <p className={`my-auto ${paddingTitle} font-responsive pt-1 ml-2 ${subtitleClass}`}>{subtitle}</p>
            )}
          </div>
        </div>
      </Card.Body>
    </div>
  </Card>
);

CompactCard.propTypes = {
  variant: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  titleClass: PropTypes.string,
  subtitleClass: PropTypes.string,
  subtitle: PropTypes.string,
  paddingTitle: PropTypes.string,
  paddingContent: PropTypes.bool,
  customSize: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func
};

CompactCard.defaultProps = {
  title: '',
  label: '',
  titleClass: '',
  subtitleClass: '',
  subtitle: '',
  variant: 'info',
  paddingTitle: 'pl-2 pb-3',
  paddingContent: false,
  customSize: '',
  active: false,
  onClick: null
};

export default CompactCard;
